export function getCurrentPeriod(matchSummary) {
    return matchSummary.periods.find(({ code }) => matchSummary.currentPeriod === code);
}
//# sourceMappingURL=getCurrentPeriod.js.map